export enum PeriodTabsOptions {
  OneDay = 'OneDay',
  ThreeDays = 'ThreeDays',
  OneWeek = 'OneWeek',
}
